import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageLayout } from '@src/common/PageLayout';

const FooterText = styled('div', {
  width: '100%',
  paddingTop: '10px',
  paddingBottom: '10px',
  margin: '0 auto',
  maxWidth: '1250px',
  fontSize: 14,
  color: '$gray8',
  height: 50,
});

const Seperator = styled('span', {
  margin: '0px 5px',
});

const FooterBar = styled('div', {
  width: '100%',
  bottom: 0,
  zIndex: 100,
  backgroundColor: '$primary2',
});

const Copyright = styled('span', {
  fontSize: 15,
});

export const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();

  return (
    <FooterBar>
      <PageLayout>
        <FooterText>
          <Copyright>&#169;</Copyright> {year} UnitedHealthcare
          <Seperator>|</Seperator>
          <span>All Rights Reserved</span>
        </FooterText>
      </PageLayout>
    </FooterBar>
  );
};
